import React from 'react';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

import envelope from 'assets/illustrations/envelope.svg';
import { MainTitle, Paragraph } from 'common/components';
import { SuccessWrapper } from 'modules/account/features/singup/components/index.styled';
import { useMutationResendActivationMail } from 'modules/account/features/singup/hooks';
import { ISignUpModel } from 'modules/account/features/singup/models';
import { useAuthState } from 'services/auth/AuthContext';

export const SignUpSuccess = ({ email }: { email: string }) => {
  const { t } = useTranslation();
  const { colors, fontFamily } = useTheme();
  const [searchParams] = useSearchParams();

  const {
    state: { formValues },
  } = useAuthState();

  const type = searchParams.get('type');

  const { mutate } = useMutationResendActivationMail(type);

  const sendActivationMailAgainHandler = () => mutate((formValues as ISignUpModel).email);

  return (
    <SuccessWrapper>
      <img src={envelope} alt="Success registration" />

      <MainTitle margin="3rem 0 1rem 0" fontSize="2rem" fontFamily={fontFamily.semiBold}>
        {t('Check your email!')}
      </MainTitle>

      <Paragraph fontFamily={fontFamily.regular} fontSize="1rem" fontWeight="400">
        {t('CheckEmailForActivationLink', {
          emailAddress: email,
        })}
      </Paragraph>

      <Paragraph fontFamily={fontFamily.regular} fontSize="1rem" fontWeight="400" margin="0">
        {t('Check your spam box')}
        <Paragraph
          fontFamily={fontFamily.semiBold}
          fontSize="1rem"
          fontWeight="400"
          margin="0 0 0 0.25rem"
          cursor="pointer"
          color={colors.primary_dark}
          textDecoration="underline"
          onClick={sendActivationMailAgainHandler}
        >
          {t('Send an activation email')}.
        </Paragraph>
      </Paragraph>
    </SuccessWrapper>
  );
};
